<template>
    <div class="z-container" @contextmenu="windowRightMenu($event)">
      <!-- 搜索框 -->
      <div :class="['search-Box',{'drop':filterC}]" :style="brush?'':'margin-top:10px'" v-if="brush">
        <span :class="['screen',{'choose':filterC}]" @click="filter()">筛选</span>
        <input :style="brush?'':'width:calc(100% - 67px)'" placeholder="请输入关键字搜索" v-model="test" @keyup.enter="currentPage = 1;currentPage = 1;screening();" />
        <span class="search" @click="currentPage = 1;currentPage = 1;screening();"></span>
        <div class="filterCriteria" v-show="filterC">
          <div class="search-conditions-box" ref="search">
            <div class="search-row">
              <div class="conditions-title">分类：</div>
              <Conditions :cont="contents" @emitChoose='choose' :choose="chooseItem" :swindow="true" ref="conditions"/>
            </div>
            <div class="choose-content-box">
              <div class="choose-title">已选择条件：</div>
              <ul>
                <li v-for="(item,index) in chooseContent"
                    :key="index">
                  <a href="javascript:;"
                    class="hover-systemBlue">{{item.name}}</a>
                  <span class="hover-systemBlue"
                        @click="del(index,item)">x</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- 展示框 -->
      <productShow :contentData="contentData"
                   :showOrNot="showOrNot"
                   :totalPage='totalPage'
                   :currentPage='currentPage'
                   :endPage='endPage'
                   :defaultBlockId='defaultId'
                   :blockData='blockData'
                   @emitCurrent='emitCurrent'
                   @emitSize='emitSize' />
    </div>
</template>
<script>
import Bus from '../bus.js'
import Conditions from "../components/chooseConditions.vue";
import productShow from "../components/productShow.vue";
export default {
    name:'specialClient',
    components: {
        Conditions,
        productShow
    },
    props:{
      blockData:Object
    },
    data () {
    return {
      keyWord:'',
      filterC:false,
      brush:true,
      that:window,
      pathArr: [],
      conditions: [{ name: '名称' }, { name: '地域' }, { name: '分类' }, { name: '规格型号' }, { name: '价格' }, { name: '描述' }],
      chooseInd: -1,
      chooseContent: [],
      chooseItem: -1,
      contentData: [],
      show: -1,
      rightShow: false,
      rMenuPos: {
        left: 0,
        top: 0
      },
      rightMenus: null,
      test: '',
      currentPage: 1,
      pageSize: 30,
      totalPage: 0,
      endPage: 1,
      showOrNot: false,
      rightType: this.$store.state.rightType,
      contents:[],
      items:'',
      ids:'',
      searchBoxShow:false,
      defaultId:'',
      basicTypes:''
    }
  },
  activated(){
    //被keepalive包裹才会触发
    document.documentElement.scrollTop = this.$route.meta.scrollTop || 0;
  },
  mounted () {
    var _this = this;
    window.addEventListener('click', () => {
      _this.rightShow = false;
    });
    
    _this.getDefaultId();
    $(window).scroll(()=>{
      _this.filterC = false;
    })
    $(document).on('click touchstart',function(e) {
      //目标对象
      var object = $(e.target);
      if(object.closest(".search-Box.drop").length == 0){
        //点击除id为srdiv的元素
        _this.filterC = false;
      }
    })
  },
  //跨级触发方法
  provide() {
      return {
        fatherMethod: this.choose,
        emitChoose:''
      }
  },
  methods: {
    windowRightMenu(ev){
      window.$defaultBlockId = this.defaultId;
      Bus.$emit('windowRight', ev, {appId:this.$appId,id:this.blockData.id,flowType:'flow'},this.blockData.flowEnName);
    },
    filter(){
      this.filterC = !this.filterC;
    },
    //传递每页条数
    emitSize (val) {
      this.pageSize = val;
      this.screening(this.items,this.ids);
    },
    //传递当前页
    emitCurrent (val) {
      this.currentPage = val;
      this.screening(this.items,this.ids);
    },
    //搜索栏
    searchData () {
      var _this = this;
      
      _this.$http.get("/zciid-deliverable/api/abduction/getScreenFlowListByAppId.json", {
        appId: _this.getQuery('appId'),
        appIdStr: _this.brush ? 'cpsqjgpt' : (_this.getQuery('appIdStr')?_this.getQuery('appIdStr'):'')
      }).then( async res => {
        // _this.contents = res.data;
        res.data.forEach((item)=>{
          item.flower = 1;
        })
        var url = '/zciid-deliverable/showPlatformStyle/flow/api/get/getMainTopNavList.json',
        data = {appId:_this.$appId,types:( _this.basicTypes == '6') ?  'third-flow-up' : 'flow-nav-prioroty',flowId:_this.blockData.id,dsfBlockId:( _this.basicTypes == '6') ? _this.defaultId : ''};
        _this.$http.get(url, data).then(resp => {
          _this.contents = [...(resp.data ? resp.data : ''),...(res.data ? res.data : '')];
        })
      })
    },
    filtrate (index, ele, i) {
      if(this.chooseContent.length) return;
      switch (index) {
        case 0:
          this.$router.replace({ path: 'flowList', query: { appId: this.$appId, id1: this.getQuery('id1'), id2: '', id3: '', ind: '' } })
          break;
        case 1:
          this.$router.replace({ path: 'flowList', query: { appId: this.$appId, id1: this.getQuery('id1'), id2: ele.id, id3: '', ind: '' } });
          break;
        case 2:
          this.$router.replace({ path: 'flowList', query: { appId: this.$appId, id1: this.getQuery('id1'), id2: this.getQuery('id2'), id3: ele.id, ind: i } });
          break;
        case 3:
          this.showOrNot = false;
          this.items = ele.name;
          this.ids = ele.id;
          this.currentPage = 1;
          this.test = '';
          this.screening(ele.name,ele.id);
          break;
      }
    },
    //点击选择条件
    choose (item) {
      this.currentPage = 1;
      if (this.chooseContent.length) {
        var Have = false;
        this.chooseContent.forEach((ele, ind) => {
          if (item.num == ele.num) {
            Have = true;
            this.chooseContent.splice(ind, 1, item);
          }
        })
        if (!Have) {
          this.chooseContent.push(item);
        }
      } else {
        this.chooseContent.push(item);
      }
      this.keyWork(item.ite.id);
    },
    keyWork (id) {
      var item = '';
      this.chooseContent.forEach((ele, ind) => {
        if (ind == 0) {
          item = ele.name
        } else {
          item += ',' + ele.name;
        }
      })
      this.items = item;
      this.ids = id;
      this.test = '';
      this.screening(item,id);
    },
    del (ind, item) {
      this.currentPage = 1;
      this.chooseContent.splice(ind, 1);
      this.chooseItem = -2;
      this.$refs.conditions.del();
      this.keyWork();
    },
    getDefaultId(){
        this.$http.get('/zciid-deliverable/api/abduction/getFloorDefaultByFloorFlowId.json',{appId:this.$appId,floorFlowId:this.blockData.id}).then(res => {
          if(res.state == 1){
            this.defaultId = res.data.id;
            this.basicTypes = res.data.basicTypes;
          }
          this.screening('');
          this.searchData();
        })
    },
    screening (item,id) {
      var _this = this;
      var url = '/zciid-deliverable/api/showPlatform/content/getAppIdContentByTypes.json',
          data={appId: _this.getQuery('appId'),floorFlowId:_this.blockData.id,flowId:id,defaultId:this.defaultId, keyWord: _this.test,pageNum: _this.currentPage,pageSize: _this.pageSize};
        
      _this.$http.get(url,data).then(res => {
        if (res.state == 1) {
          _this.currentPage = res.data.getPageNum;
          _this.totalPage = res.data.getTotalNum;
          _this.endPage = res.data.getPageCount;
          var dataArr = res.data.contentJsonArr;
          if (dataArr) {
            if (_this.getQuery('appIdStr')&&(_this.getQuery('appIdStr').indexOf('orgic') >-1 || _this.getQuery('appIdStr').indexOf('sqsjyxglzpt')>-1)) {
              var arrays = [];
              res.data.contentJsonArr.forEach((ele) => {
                var newObject = {};
                newObject.appId = 'sqsjyxglzpt';
                newObject.blockId = '';
                newObject.nodeId = '';
                newObject.contentId = ele.contentId;
                newObject.contentRows = '';
                newObject.contentShowFlowPosition = '';
                newObject.contentShowRowsSort = '';
                newObject.sceneGroupId = '';
                newObject.sceneId = '';
                newObject.isYyz = 0;
                newObject.userId = '';
                newObject.contentWzUrl = ele.wzUrl;
                newObject.blockDataType = '';
                newObject.releaseId = '';
                newObject.sign = '';
                newObject.standardJson = [{ 'standardName': '名称', 'standardData': ele.name, 'fileTypeDetail': '', 'standardType': 0, 'isShow': 1 }, { 'standardName': '头像', 'standardData': ele.photo, 'fileTypeDetail': '2' }];
                arrays.push(newObject);
              })
              dataArr = arrays;
            }
            _this.contentData = [];
            dataArr.forEach((item) => {
              var pictures = [], others = [], btns = [], contentId = '', blockId = '';
              contentId = item.contentId;
              blockId = item.blockId;
              item.standardJson.forEach((ele) => {
                if (ele.standardData && (ele.standardData.indexOf('.mp4') > 0 || ele.standardData.indexOf('.png') > 0 || ele.standardData.indexOf('.jpg') > 0 || ele.standardData.indexOf('.jpeg') > 0)) {
                  pictures.push(ele.standardData);
                } else {
                  others.push(ele);
                }
              })
              _this.contentData.push({
                contentId: contentId,
                blockId: blockId,
                appId:item.appId,
                appName:item.appName,
                contentWzUrl:item.contentWzUrl,
                contentDsfWzUrl:item.contentDsfWzUrl,
                subDomain:item.subDomain,
                nodeId: item.nodeId,
                pictures: pictures,
                others: others,
                btns: btns,
                sign: item.sign,
                tags: item.standardJson,
                standAllName: others[0].standardData
              });
            })
          } else {
            _this.contentData = [];
          }
          
          var iframe = _this.$refs.search;
          if (iframe && _this.currentPage>1) {
              iframe.scrollIntoView({ behavior: "smooth" });
          }
        } else {
          _this.contentData = [];
        }
        _this.showOrNot = true;
      })
    }
  }
}
</script>
<style scoped>
/* 搜索框样式 */
.search-box {
  margin-bottom: 20px;
}
.search-box input {
  width: 91%;
  height: 42px;
  border: 1px solid #ddd;
}
.search-box button {
  margin-left: 1%;
  width: 6.7%;
  height: 42px;
  background-color: #4697f9;
  border-radius: 3px;
  color: #fff;
}

/* brush搜索框 */

.search-Box{
  margin:0 auto;
  margin-top: 20px;
  width:1198px;
  height:40px;
  position:relative;
  border-radius:20px;
  border:1px solid #ddd;
  position: relative;
  font-size: 14px;
}
.search-Box.drop{
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.search-Box .filterCriteria{
  position: absolute;
  top: 38px;
  left: -1px;
  z-index: 9999;
  width: calc(100% + 2px);
  background-color: #fff;
  border: 1px solid #ddd;
  /* padding: 0 20px; */
  overflow: hidden;
  box-sizing: border-box;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
}
.search-Box .screen{
  display: inline-block;
  height: 30px;
  line-height: 30px;
  width: 70px;
  border-right: 1px solid #ddd;
  margin: 4px 0 5px 20px;
  box-sizing: border-box;
  cursor: pointer;
  background: url("../assets/image/images/icons/expand.png") no-repeat 36px center;
}
.search-Box .screen.choose{
  color: #0d78cf;
  background: url("../assets/image/images/icons/retract.png") no-repeat 36px center;
}
.search-Box .search{
  position: absolute;
  display: inline-block;
  right: 24px;
  top: 12px;
  background: url("../assets/images/icons/search_blue_16.png") no-repeat;
  width: 16px;
  height: 16px;
  vertical-align: middle;
  cursor: pointer;
}
.search-Box input{
  width:calc(100% - 155px);
  height:calc(100% - 2px);
  margin-left:16px;
  border:0;  
  font-size: 14px;
  color:#333;
}
.search-Box input::-webkit-input-placeholder{
  color:#999;
}
.search-Box input:-moz-placeholder{
  color:#999;
}
.search-Box input::-moz-placeholder.search-Box{
  color:#999;
}
.search-Box input::-ms-input-placeholder{
  color:#999;
}
@media screen and (max-width: 768px) {
  .search-Box{
    width: calc( 100% - 20px );
    padding: 0 10px;
    box-sizing: border-box;
  }
}


/* 面包屑样式 */
.location {
  height: 56px;
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #666;
  background: url("~@/assets/image/images/icons/icon_crumbs_house.png")
    no-repeat 0 21px;
  padding-left: 14px;
  width: calc(100% - 14px);
  width: -moz-calc(100% - 14px);
  width: -webkit-calc(100% - 14px);
  width: -o-calc(100% - 14px);
  width: -ms-calc(100% - 14px);
  position: relative;
}
.location .fl {
  display: flex;
  align-items: center;
}
.location .crumb-size {
  max-width: 300px;
  height: 56px;
  line-height: 56px;
  padding: 0 6px;
  word-break: keep-all;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.location .crumb-size a {
  position: relative;
}
.location .crumb-size:hover a {
  color: #0d78cf;
}
.location .crumb-size:hover a::after {
  display: inline-block;
}
.level-area:hover + .crumb-size a::after {
  display: inline-block;
}
.location .crumb-size a::after {
  content: "";
  display: none;
  width: 0;
  height: 0;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-bottom: 7px solid #fff;
  position: absolute;
  left: 35%;
  top: 42px;
  z-index: 999;
}
/* 面包屑悬浮层 */
.level-area {
  position: absolute;
  left: 0;
  right: 0;
  top: 49px;
  z-index: 10;
}
.level-area .level-rows {
  background: #fff;
  box-shadow: 0 0 10px rgb(0 0 0 / 20%);
  padding: 10px;
  box-sizing: border-box;
}
.level-area .level-rows .info {
  display: inline;
  height: 34px;
  line-height: 28px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: auto;
  font-size: 14px;
  margin-right: 15px;
}
.level-area a:hover {
  color: #4697f9;
}
/* 搜索栏样式 */
.search-conditions-box.border {
  border: 1px solid #dddddd;
}
.search-row{
  position: relative;
  max-height: 330px;
  overflow: auto;
}
.search-row .conditions-title{
  position: absolute;
  left: 0px;
  top: 9.5px;
  width: 110px;
  font-size: 14px;
  line-height: 26px;
  text-align: right;
}
.choose-content-box {
  background: #f5f5f5;
  padding: 7px 0px;
  position: relative;
  border-top: none;
  height: 28px;
}
.choose-content-box .choose-title {
  width: 110px;
  position: absolute;
  left: 0px;
  top: 9px;
  font-size: 14px;
  line-height: 26px;
  text-align: right;
}
.choose-content-box ul {
  margin-top: 2px;
  margin-left: 110px;
  height: 24px;
  overflow: hidden;
}
.choose-content-box ul li {
  position: relative;
  border-radius: 3px;
  padding: 0 20px 0 10px;
  float: left;
  margin: 0 5px;
  border: 1px solid #4697f9;
  line-height: 24px;
}
.choose-content-box ul li a {
  display: block;
  line-height: 22px;
  font-size: 14px;
}
.choose-content-box ul li span {
  position: absolute;
  right: 3px;
  top: -3px;
  font-size: 20px;
  cursor: pointer;
  color: #999;
}
</style>


// WEBPACK FOOTER //
// src/components/specialClient.vue